import * as React from "react";
import { toIsoDate, twvDateView } from "../detail/twvFrist";
import "./vorgangV3.css";

/**
 * EIN Datumsfeld mit sprechender Zusatzangabe („überfällig", „heute",
 * „übermorgen"). Wiedervorlage und Frist stehen als GETRENNTE Zeilen im
 * Eigenschaften-Raster (PO 03.09.2026: „twv und frist separat also darunter") —
 * nebeneinander in einer Zeile „Termine" las sich das eine als Zusatz des
 * anderen, obwohl es zwei unabhängige Termine sind.
 *
 * Die Ableitung des relativen Wortes und seines Farbtons kommt aus
 * `twvFrist.ts` — reine, getestete Datumslogik, in beiden Ansichten dieselbe.
 * Kalendertermine sind aus der Ansicht gefallen; TWV und Frist bleiben, ohne
 * sie gäbe es keine Wiedervorlage.
 */
export const DatumFeld: React.FC<{
    label: string;
    value?: string | null;
    canEdit: boolean;
    onSave: (next: string | null) => void;
}> = ({ label, value, canEdit, onSave }) => {
    const iso = toIsoDate(value);
    const view = twvDateView(iso);
    return (
        <span className="vg3-datum">
            <input
                type="date"
                className="vg3-datum-in"
                value={iso}
                disabled={!canEdit}
                aria-label={label}
                onChange={(e) => onSave(e.target.value || null)}
            />
            {view?.relative && <span className={`vg3-rel ${view.tone}`}>{view.relative}</span>}
            {!iso && !canEdit && <span className="vg3-leer">—</span>}
        </span>
    );
};
